"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Carret_1 = __importDefault(require("../../icons/Carret"));
var styles_1 = require("./styles");
function SlideShow(_a) {
    var slides = _a.slides, style = _a.style, className = _a.className;
    var _b = react_1.useState(0), xCoordinate = _b[0], setXCoordinate = _b[1];
    return (react_1.default.createElement(styles_1.MainContainer, { style: style === null || style === void 0 ? void 0 : style.root, className: className },
        slides.map(function (slide, index) {
            return (react_1.default.createElement(styles_1.Slide, { key: index, src: slide, style: __assign({ transform: "translateX(" + xCoordinate + "%)" }, style === null || style === void 0 ? void 0 : style.slide) }));
        }),
        slides.length > 1 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.Button, { onClick: function () {
                    return setXCoordinate(xCoordinate >= 0
                        ? (slides.length - 1) * -100
                        : xCoordinate + 100);
                }, direction: "left", style: style === null || style === void 0 ? void 0 : style.buttons },
                react_1.default.createElement(Carret_1.default, { direction: "left", height: "16px" })),
            react_1.default.createElement(styles_1.Button, { onClick: function () {
                    return setXCoordinate(xCoordinate <= (slides.length - 1) * -100
                        ? 0
                        : xCoordinate - 100);
                }, direction: "right", style: style === null || style === void 0 ? void 0 : style.buttons },
                react_1.default.createElement(Carret_1.default, { height: "16px" }))))));
}
exports.default = SlideShow;
//# sourceMappingURL=index.js.map